import type { FormControlLabelProps } from '@mui/material';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';

export type LookoCheckboxType = {
  disabled?: boolean;
  label?: React.ReactNode;
  value?: FormControlLabelProps['value'];
  checked?: boolean;
  onChange?: FormControlLabelProps['onChange'];
};
/**
 * 체크박스.
 *
 * ```tsx
 * // 선택됨
 * <LookoCheckbox label="항목" checked={true} onChange={handleChange} />
 * // 선택 안됨
 * <LookoCheckbox label="항목" checked={false} onChange={handleChange} />
 * // 비활성화
 * <LookoCheckbox label="항목" checked={true} disabled />
 * ```
 */
export const LookoCheckbox = (props: LookoCheckboxType) => {
  return (
    <FormControlLabel
      {...props}
      label={<Typography variant="Body_Looko">{props.label}</Typography>}
      control={
        <Checkbox
          size="small"
          sx={{
            padding: 0.5,
            margin: 0,
            width: 32,
            height: 32,
          }}
        />
      }
      sx={{ margin: 0 }}
    />
  );
};
